import { SubscriptionDiscount } from '../types/subscription-discounts';

export function getShippingDiscountValue(productCost: number, subscriptionDiscount: SubscriptionDiscount): number {
  if (!subscriptionDiscount) {
    return 0;
  }

  const {
    threshold: { amount },
    minDiscount,
    maxDiscount,
  } = subscriptionDiscount;

  return productCost >= amount ? maxDiscount : minDiscount;
}
